/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings
 */
export interface GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings
     */
    'detectedDpi'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings
     */
    'calculatedDpi'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings
     */
    'colorGradation'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings
     */
    'heightMillis'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarnings
     */
    'widthMillis'?: GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsWidthMillisEnum;
}

export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsDetectedDpiEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsDetectedDpiEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsDetectedDpiEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsCalculatedDpiEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsCalculatedDpiEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsCalculatedDpiEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsColorGradationEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsColorGradationEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsColorGradationEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsHeightMillisEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsHeightMillisEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsHeightMillisEnum];
export const GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsWidthMillisEnum = typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsWidthMillisEnum[keyof typeof GetFraudLockedCardTransaction200ResponseOneOfEvidenceListInnerWarningsWidthMillisEnum];


